import React, {Component} from 'react';
import Product from './Product';
import Title from './Title';
import{ProductConsumer} from '../context';
export default class ProductList extends Component {

    render(){

        return(
        
            // <div>
            <React.Fragment>
                <div className="py-5">
                <div className="container">
                <h1 className="text-capitalize text-center ">Featured Products</h1>
                <hr style={{width:"100%"}}/>
                <div className="row">
                <ProductConsumer>
                    {value =>{
                        return value.products.map( product =>{
                           return <Product key={product.id} product={product}/>;
                         });
                     }}

                </ProductConsumer>
                </div>
                </div>
                </div>
                
                 </React.Fragment>
                // <Product/>
            // </div>
        )
    }
}